export const columns = [
  {
    title: "工程合同编号",
    width: 200,
    dataIndex: "bizNo",
    key: "bizNo",
  },
  {
    title: "合同名称",
    width: 300,
    dataIndex: "name",
    key: "name",
  },
  {
    title: "项目名称",
    width: 200,
    dataIndex: "projectName",
    key: "projectName",
  },
  {
    title: "甲方",
    width: 200,
    dataIndex: "firstCooperationCompanyName",
    key: "firstCooperationCompanyName",
  },
  {
    title: "签订日期",
    width: 150,
    dataIndex: "signDate",
    key: "signDate",
  },
  {
    title: "合同金额（￥）",
    width: 200,
    slots: { customRender: "amount" },
  },
  {
    title: "经办人",
    width: 150,
    dataIndex: "agentTenantUserName",
    key: "agentTenantUserName",
  },
  {
    title: "项目经理",
    width: 150,
    dataIndex: "managerTenantUserName",
    key: "managerTenantUserName",
  },
  {
    title: "收款状态",
    width: 150,
    dataIndex: "receivableAmountStatusName",
    key: "receivableAmountStatusName",
  },
  {
    title: "合同状态",
    width: 150,
    dataIndex: "contractStatusName",
    key: "contractStatusName",
  },
  {
    title: "审批状态",
    width: 150,
    dataIndex: "flowStatusName",
    key: "flowStatusName",
  },
  {
    title: "最近更新时间",
    width: 200,
    dataIndex: "lastModifiedTime",
    key: "lastModifiedTime",
  },
];
